import { useState } from "react"
import fb from "../../../../assets/images/svg/ic_fb_12x12.svg";
import { useEffect } from "react";

const ImagePageFb = ({ src, alt }) => {
   const [isError, setIsError] = useState(false);
   const handleError = (e) => {
      if (!isError) {
         setIsError(true);
         e.target.src = fb;
      }
   }

   useEffect(() => {
      setIsError(false);
   }, [src]);

   return <img src={src} alt={alt} onError={handleError} />
}

export default ImagePageFb